export default "__VITE_ASSET__zP6ZgNye__"